var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TimePicker',{attrs:{"isDisabled":_vm.isDisabled,"label":_vm.label,"startTime":_vm.startTime},on:{"onChange":_vm.timeChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }